export default "__VITE_ASSET__DoINm3hW__"